import { render, staticRenderFns } from "./bookingSpace.vue?vue&type=template&id=12e410fe&scoped=true&"
import script from "./bookingSpace.vue?vue&type=script&lang=js&"
export * from "./bookingSpace.vue?vue&type=script&lang=js&"
import style0 from "./bookingSpace.vue?vue&type=style&index=0&id=12e410fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e410fe",
  null
  
)

export default component.exports